import { render } from "./Propose.vue?vue&type=template&id=2830699a&scoped=true&ts=true"
import script from "./Propose.vue?vue&type=script&lang=ts"
export * from "./Propose.vue?vue&type=script&lang=ts"

import "./Propose.vue?vue&type=style&index=0&id=2830699a&lang=scss&scoped=true"

import exportComponent from "D:\\work\\h5\\2024sclh\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2830699a"]])

export default __exports__